export default "__VITE_ASSET__DTnHVMjD__";